import { render } from "./step3.vue?vue&type=template&id=b4b6e6e8&scoped=true&ts=true"
import script from "./step3.vue?vue&type=script&lang=ts"
export * from "./step3.vue?vue&type=script&lang=ts"

import "./step3.vue?vue&type=style&index=0&id=b4b6e6e8&lang=sass&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b6e6e8"]])

export default __exports__